//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadOtherApplicationAttachment } from '@/https/otherApplication'
import { Upload } from '@/constant/componentConfig'
import { cloneDeep } from '@/utils/lodash'
import { IMAGE_FILE } from '@/constant/dict'
import { toast } from '@/utils/toast.js'
import TFixedAttachment from '../../enroll/attachment/TFixedAttachment'

export default {
  components: { TFixedAttachment },

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      formData: {},
      fixedAttachmentInfoList: [],
      uploadStatus: null,
    }
  },

  computed: {
    needFixAttachmentFlag () {
      return +this.options?.bmbMbDetailItem?.fjyqdm === 2
    },

    needNotFixAttachmentFlag () {
      return +this.options?.bmbMbDetailItem?.fjyqdm === 3
    },

    renderData () {
      const configData = this.options?.bmbMbDetailItem

      return [
        new Upload({
          row: true,
          value: 'attachmentWids',
          apiMethod: uploadOtherApplicationAttachment,
          prefixPosition: 'top',
          required: configData.fjsfbtdm === '1',
          accept: IMAGE_FILE,
          tip: configData.fjscsm,
          fileCount: +configData?.fjgssx || 0,
          label: '附件',
          params: { ksWid: this.options?.ksxxItem?.wid },
          maxSize: `${+configData?.fjdxsx}MB`,
        }),
      ]
    },
  },

  watch: {
    options: {
      handler (val) {
        if (Object.keys(val)?.length) {
          this.formData.attachmentWids = val?.fjList?.map((el) => {
            const temp = {
              url: el.fjdz,
              fileName: el.fjmc,
              name: el.fjmc,
              status: 'done',
            }

            return {
              ...temp,
              file: temp,
            }
          }) || []
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    uploadOtherApplicationAttachment,

    handlerChangeFixed (attachment) {
      this.attachmentList = cloneDeep(attachment)
    },

    // 对外暴露并被父组件使用，禁止删除或更改此方法名称
    async filterSaveParams () {
      let flag = true
      let fjList = []

      if (this.needFixAttachmentFlag) {
        flag = await this.$refs.fixAttachment.validate()
        fjList = this.$refs.fixAttachment.attachmentList.map((el) => {
          return {
            fjdz: el.url,
            fjmc: el.fjmc || el.fileName,
          }
        }).filter((el) => el.fjdz)
      }


      if (this.needNotFixAttachmentFlag) {
        fjList = this.formData.attachmentWids.map((el) => {
          return {
            fjdz: el.url,
            fjmc: el.fjmc || el.fileName,
          }
        })

        flag = this.options?.bmbMbDetailItem.fjsfbtdm === '0' || fjList.length > 0
      }


      if (!flag) {
        toast('请完善附件信息!')
      }


      const params = {
        ksWid: this.options.ksxxItem.wid,
        fjList,
      }

      return {
        validate: flag,
        params,
      }
    },
  },
}
